module.exports = __webpack_public_path__ + "img/wf-work-example-text.048faf70.svg";